import { SearchInput, SectionContainer, Table, HStack, VStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import { useNavigation } from '@react-navigation/native';
import React, { useCallback, useState } from 'react';
import { useRecoilValue } from 'recoil';

import { SignedInNavigationScreenNavigationProp } from '../../../../routes/types';
import {
  investmentStrategyFilterDiversifierAtom,
  investmentStrategyFilterPositiveAtom,
} from '../../../../store/home/conversion/atom';

import { FilterButton } from './components/FilterButton';
import {
  investmentStrategyListTypes,
  InvestmentStrategyType,
  moduleName,
  sectionContainerOptions,
} from './constants';
import { InvestmentStrategyTypes } from './types';

export const InvestmentStrategyDesktop: React.FC<InvestmentStrategyTypes.Props> = () => {
  const [selectedViewOption, setSelectedViewOption] = useState<InvestmentStrategyType>('positive');
  const [searchTerm, setSearchTerm] = useState<string>('');
  const { navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();
  const ContentComponent = investmentStrategyListTypes[selectedViewOption];
  const { appliedFilters: appliedFiltersPositive } = useRecoilValue(
    investmentStrategyFilterPositiveAtom
  );
  const { appliedFilters: appliedFiltersDiversifier } = useRecoilValue(
    investmentStrategyFilterDiversifierAtom
  );

  let selectedFilterCount =
    selectedViewOption === 'positive'
      ? appliedFiltersPositive.length
      : appliedFiltersDiversifier.length;

  if (searchTerm) {
    selectedFilterCount = 0;
  }

  const handleFilter = useCallback(() => {
    if (selectedViewOption === 'positive') {
      navigate('HomeInvestmentStrategyFilterPositive');
    } else {
      navigate('HomeInvestmentStrategyFilterDiversifier');
    }
  }, [navigate, selectedViewOption]);

  const handleSearch = useCallback((value: string) => {
    setSearchTerm(value);
  }, []);

  const handleClear = useCallback(() => {
    setSearchTerm('');
  }, []);

  const onViewChange = useCallback((value: string) => {
    setSelectedViewOption(value as InvestmentStrategyType);
  }, []);

  return (
    <SectionContainer
      flex={1}
      title={moduleName}
      withFilter
      withSeparator
      singleFilterLabel="Selecione uma opção:"
      multipleFilterLabel="Selecione uma opção:"
      filterOptions={sectionContainerOptions}
      selectedOption={selectedViewOption}
      onFilterChange={onViewChange}
      minHeight="fit-content">
      <VStack space={Spacing['stack.nano']}>
        <HStack alignItems="center" width="100%" flex={1}>
          <HStack space={Spacing['stack.nano']} flex={1}>
            <SearchInput
              hideSearchButtonOnDesktop={false}
              onSearch={handleSearch}
              onClear={handleClear}
              placeholder="Pesquise por cliente"
            />
          </HStack>
          <FilterButton onPress={handleFilter} appliedFilterCount={selectedFilterCount} />
        </HStack>
        <Table isLoading={false}>
          <ContentComponent searchTerm={searchTerm} />
        </Table>
      </VStack>
    </SectionContainer>
  );
};
